import { useEffect } from 'react';

const useMountEffect = (effectFn) => {
	useEffect(effectFn, []);
}

export {
	useMountEffect
}
